import { Link } from 'react-router-dom'
import cx from 'classnames'
import { ArrowSquareOut as IconArrowSquareOut } from 'phosphor-react'
import React from 'react'
import { Typography } from '@lightbeamai/design-system'

interface IProps {
  icon?: React.ReactElement
  className?: string
  innerClass?: string
  outerClass?: string
  tooltip?: string
  content: string | number | React.ReactElement
  link: string | { search?: string; pathname?: string }
  newTabOnClick?: boolean
  showExternalLinkIcon?: boolean
}

const TitleColumnWithTooltip = ({
  icon = <></>,
  className = '',
  content,
  link = '',
  innerClass = '',
  tooltip,
  newTabOnClick = false,
  showExternalLinkIcon = true,
  outerClass = ''
}: IProps): React.ReactElement => {
  const isAbsoluteUrl = (url: string) => /^(?:[a-z]+:)?\/\//i.test(url)

  return (
    <div className={outerClass}>
      {icon}
      {typeof link === 'string' && isAbsoluteUrl(link) ? (
        <a
          href={link}
          className={cx('ag-title-column truncate', {
            [className]: className,
            'is-external-link': newTabOnClick
          })}
          {...(newTabOnClick ? { target: '_blank', rel: 'noreferrer' } : {})}
          title={tooltip || (content as string)}
          data-test-id="datatable-title-column-with-tooltip"
        >
          <Typography
            as="div"
            color="primary"
            className={cx('truncate', { [innerClass]: innerClass })}
          >
            {content}
          </Typography>
          {newTabOnClick && showExternalLinkIcon && (
            <span className="icon-external xs-pl-4">
              <IconArrowSquareOut size="16" color="var(--color-primary-light)" weight="bold" />
            </span>
          )}
        </a>
      ) : (
        <Link
          to={link}
          className={cx('ag-title-column truncate', {
            [className]: className,
            'is-external-link': newTabOnClick
          })}
          {...(newTabOnClick ? { target: '_blank', rel: 'noreferrer' } : {})}
          title={tooltip || (content as string)}
          data-test-id="datatable-title-column-with-tooltip"
        >
          <Typography
            as="div"
            color="primary"
            className={cx('truncate', { [innerClass]: innerClass })}
          >
            {content}
          </Typography>
          {newTabOnClick && showExternalLinkIcon && (
            <span className="icon-external xs-pl-4">
              <IconArrowSquareOut size="16" color="var(--color-primary-light)" weight="bold" />
            </span>
          )}
        </Link>
      )}
    </div>
  )
}

export default TitleColumnWithTooltip
